module.exports = { id: "tooltip", url: "/build/app/img/symbols.svg#tooltip", viewBox: "", toString: function() { return this.url; } };